// extracted by mini-css-extract-plugin
export default {"card":"ClientPanelCard_card__CAR00","first":"ClientPanelCard_first__gj4OD"};